import { useNavigate } from 'react-router-dom';

import { useBundle } from '@amzn/react-arb-tools';

import { isRebrandingWeblabEnabled } from 'src/clients/weblab/weblab-client';
import { OrganizationInformationFormValues } from 'src/components/pages/intake-form/FormEnums';
import { OrganizationInformationForm } from 'src/components/pages/intake-form/forms/OrganizationInformationForm';
import { INTAKE_FORM_PAGE_BUNDLE_NAME, FormStrings, INFORMATION_FORM_STORAGE } from 'src/constants';
import { ROUTES } from 'src/enums/Routes';
import { t } from 'src/helpers';

import { IntakeFormTemplate } from './IntakeFormTemplate';

export const InformationFormPage = () => {
  const navigate = useNavigate();
  const [formBundle] = useBundle(INTAKE_FORM_PAGE_BUNDLE_NAME);

  // load saved draft
  const savedData = localStorage.getItem(INFORMATION_FORM_STORAGE);
  const defaultValues = savedData ? JSON.parse(savedData) : {};

  const handleSubmit = (data: OrganizationInformationFormValues) => {
    const combined = {
      ...data,
      completedStep: 1,
    };

    localStorage.setItem(INFORMATION_FORM_STORAGE, JSON.stringify(combined));

    navigate(ROUTES.INTAKE_PAGE_STEP_2, { replace: true });
  };

  return (
    <IntakeFormTemplate activeStep={0}>
      <OrganizationInformationForm
        isRebrandingActive={isRebrandingWeblabEnabled}
        handleFormSubmit={handleSubmit}
        intakeFormBundle={formBundle}
        ctaLabel={t(formBundle, FormStrings.CONTINUE)}
        defaultValues={defaultValues}
      />
    </IntakeFormTemplate>
  );
};
